import { useRef } from "react";
import { useFrame } from "@react-three/fiber";
import { useSimulationStore } from "../store/simulationStore";
import { useSceneStore } from "../store/sceneStore";

/**
 * Avança o relógio no loop R3F.
 * Sincroniza o estado React (~5 Hz) para a UI, sem depender do FPS nominal.
 */
export function useSimulationClock(): void {
  const advance = useSimulationStore((s) => s.advance);
  const syncUiDate = useSimulationStore((s) => s.syncUiDate);
  const setFps = useSceneStore((s) => s.setFps);
  const fpsAccum = useRef({ frames: 0, time: 0 });
  const uiAccum = useRef(0);

  useFrame((_, delta) => {
    const clamped = Math.min(delta, 0.1);
    advance(clamped, false);

    uiAccum.current += clamped;
    if (uiAccum.current >= 0.2) {
      uiAccum.current = 0;
      syncUiDate();
    }

    fpsAccum.current.frames += 1;
    fpsAccum.current.time += clamped;
    if (fpsAccum.current.time >= 0.5) {
      setFps(Math.round(fpsAccum.current.frames / fpsAccum.current.time));
      fpsAccum.current = { frames: 0, time: 0 };
    }
  });
}
